/** 同域登录后跳回 studio 子路径（邀请接受等） */
export function buildLoginForStudioPath(studioPath: string): string {
  const next = studioPath.startsWith('/') ? studioPath : `/${studioPath}`
  return `/auth/login?redirect=${encodeURIComponent(next)}`
}
